import React,{useEffect} from 'react';
import hamburgerMenuIcon from "../assets/images/common/header/menu.png";
import {NavLink} from "react-router-dom";

const Navbar = () => {
    useEffect(() => {
        // Close the navbar after clicking on a list item
        const navItems = document.querySelectorAll('.navbar-nav li');
        navItems.forEach((item) => {
            item.addEventListener('click', () => {
                const navbarToggle = document.querySelector('.navbar-toggler');
                if (navbarToggle.getAttribute('aria-expanded') === 'true') {
                    navbarToggle.click();
                }
            });
        });
    }, []);
    return (
        <div className="custom-container">
            <nav className="navbar navbar-expand-xl">
                <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <img width="35" src={hamburgerMenuIcon} alt=""/>
                </button>
                <div className="collapse navbar-collapse w-100" id="navbarNav">
                    <ul className="navbar-nav pb-xl-3 w-100">
                        <li className="nav-item">
                            <NavLink className="nav-link" to='/'>Home </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to='/about'>About Us</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to='/services'>Services</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to='/acts-rules-orders'>Acts, Rules & Orders</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to='/media-events'>Media & Event</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to='/guideline'>Guideline</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to='/faq'>FAQ</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to='/contact'>Contacts</NavLink>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;
